import { Star } from '@mui/icons-material'
import { Tooltip } from '@mui/material'
import type { SxProps, Theme } from '@mui/material/styles'

import type React from 'react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { formatPopularTooltip } from '../../domain/popular-items'
import { usePopularItemStats } from '../../store/popularItemsStore'
import { ImageBadge } from './image-badge'

type Props = {
  itemId: string
  sx?: SxProps<Theme>
}

export const PopularBadge: React.FC<Props> = ({ itemId, sx }) => {
  const { t } = useTranslation()
  const stats = usePopularItemStats(itemId)
  const [open, setOpen] = useState(false)

  const title = formatPopularTooltip(t, stats)

  const handleClick = (event: React.MouseEvent) => {
    event.stopPropagation()
    setOpen((isOpen) => !isOpen)
  }

  const badge = (
    <ImageBadge
      icon={<Star fontSize="small" />}
      label={t('marketplace:popular', { defaultValue: 'Popular' })}
      color="secondary"
      sx={sx}
      onClick={title ? handleClick : undefined}
    />
  )

  if (!title) return badge

  return (
    <Tooltip
      arrow
      describeChild
      title={title}
      open={open}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      disableTouchListener
      slotProps={{ tooltip: { sx: { maxWidth: 260 } } }}>
      {badge}
    </Tooltip>
  )
}
